module.exports = __webpack_public_path__ + "static/media/seafoodBoil.2157a2f0.jpeg";